// Vendor Libs
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {Droppable} from 'react-beautiful-dnd';

// Components
import StorefrontItem from './storefront-item';

// Styled Components
const getBackgroundColor = (isDraggingOver, isDraggingFrom) =>
  isDraggingOver ? '#FFEBE6' : isDraggingFrom ? '#E6FCFF' : '#EBECF0';

const Container = styled.div`
  margin: 0rem 4rem;
  border: 1px solid lightgrey;
  border-radius: 2px;
  width: 25rem;
  min-width: 200px;

  display: flex;
  flex-direction: column;
`;
const Title = styled.h3`
  margin: 0px;
  padding: 10px;
  background-color: transparent;
`;
const ItemList = styled.div`
  padding: 8px;
  background-color: ${({isDraggingOver, isDraggingFrom}) => getBackgroundColor(isDraggingOver, isDraggingFrom)};
  flex-grow: 1;
  min-height: 100px;
`;

const StorefrontList = ({container, items, isDropDisabled, active, maxActive, onClick}) => (
  <Container>
    <Droppable droppableId={container.id} isDropDisabled={isDropDisabled}>
      {(provided, snapshot) => (
        <ItemList
          ref={provided.innerRef}
          {...provided.droppableProps}
          isDraggingFrom={Boolean(snapshot.draggingFromThisWith)}
          isDraggingOver={snapshot.isDraggingOver}
        >
          <Title>{container.title}</Title>
          {items.map((item, index) => (
            <StorefrontItem
              active={active}
              index={index}
              item={item}
              key={item.id}
              maxActive={maxActive}
              onClick={onClick}
            />
          ))}
          {provided.placeholder}
        </ItemList>
      )}
    </Droppable>
  </Container>
);

StorefrontList.propTypes = {
  active: PropTypes.bool,
  container: PropTypes.object.isRequired,
  isDropDisabled: PropTypes.bool,
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  maxActive: PropTypes.number,
  onClick: PropTypes.func,
};

StorefrontList.defaultProps = {
  active: false,
};

export default StorefrontList;
